<template>
  <div class="campaigns">
    <h6 class="text-center mb-3">Campaigns Successfully Accomplished</h6>
    <h3 class="color_orange text-center">Succesfully Completed</h3>
    <swiper :modules="modules" :slides-per-view="1" :space-between="0" :pagination="{ clickable: true }"
      @swiper="onSwiper" @slideChange="onSlideChange">
      <swiper-slide v-for="(item, idx) in c_data" :key="idx">
        <div class="item">
          <table class="tbl_new responsive" width="100%" style="
              border-spacing: 0px;
              margin: auto;
              font-family: 'Montserrat', sans-serif;
            " cellspacing="0" cellpadding="0" border="0">
            <thead>
              <tr>
                <th>
                  <div>Campaign Name</div>
                </th>
                <th>
                  <div>Volume Sent</div>
                </th>
                <th>
                  <div>Opens</div>
                </th>
                <th>
                  <div>Clicks</div>
                </th>
                <th>
                  <div>Country</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Campaign Name"> {{ item.c_name }}</td>
                <td data-label="Volume Sent">{{ item.c_vol }}+</td>
                <td data-label="Opens">{{ item.c_opens }}<span> </span></td>
                <td data-label="Clicks">{{ item.c_clicks }}
                  <!-- <small>(11%)</small> -->
                </td>
                <td data-label="Country">
                  <!-- <img :src="flagImage(item.c_flag)" alt="" /> {{ item.c_country }}  -->
                  <div style="width: 200px;">
                    <swiper slides-per-view="1" :autoplay="{ delay: 3000, disableOnInteraction: false }" :loop="true"
                      class="country-flag-swiper">
                      <swiper-slide v-for="(item2, index) in item.flag_data" :key="index" style="padding: 0 !important;">
                        <div class="d-flex justify-content-center">
                          <div>
                            <img :src="item2.flag" :alt="`Flag ${index + 1}`" />
                          </div>
                          <p
                            style="margin-top: 8px; font-weight: 500; font-size: 14px;padding-left: 8px; align-items: center;">
                            {{ item2.flagname }}</p>
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="round_graphics">
            <img src="@/assets/images/uparrow.png" alt="" />
            <h5>
              <span>{{ item.days }}</span> <br />
              Days
            </h5>
            <div class="btmcorner">
              Started <br />
              {{ item.c_started }}
            </div>
            <div class="topcorner">
              Completed <br />
              <span style="color: #838383;">{{ item.c_ended }}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <router-link to="/contact-us" class="details">Click for detail report</router-link>
  </div>
</template>

<script>
import { Autoplay, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import flag1 from '@/assets/images/flag1.png';
import flag2 from '@/assets/images/flag2.png';
import flag3 from '@/assets/images/flag12.png';
import flag4 from '@/assets/images/flag3.png';
import flag5 from '@/assets/images/flag17.png';
import flag6 from '@/assets/images/flag8.png';
import flag7 from '@/assets/images/India.png';
import flag8 from '@/assets/images/flag14.png';
import flag9 from '@/assets/images/flag6.png';
import flag10 from '@/assets/images/flag20.png';

export default {
  name: "CampaignSlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      c_data: [
        // {
        //   c_name: "Dafabet",
        //   c_started: "09-20-2022",
        //   c_vol: "400,000",
        //   c_opens: "37591(9.39%)",
        //   c_clicks: 3291,
        //   c_flag: "Malaysia.png",
        //   c_country: "Malaysia",
        //   rank: 1,
        //   c_bg: "#0089b1",
        // },
        {
          c_name: "Technius Ltd",
          c_started: "October 31,2024",
          c_ended:"November 11,2024",
          c_vol: "1,000,000",
          c_opens: "107,713",
          c_clicks: 10340,
          c_flag: "flag9.png",
          c_country: "US",
          rank: 2,
          c_bg: "#308900",
          days:'12',
          flag_data: [
            {
              flag: flag1,
              flagname: 'US'
            },
            {
              flag: flag2,
              flagname: 'Germany'
            },
            {
              flag: flag3,
              flagname: 'Japan'
            },
            {
              flag: flag4,
              flagname: 'UK'
            },
            {
              flag: flag5,
              flagname: 'France'
            },
            {
              flag: flag6,
              flagname: 'Canada'
            },
            {
              flag: flag7,
              flagname: 'India'
            },
            {
              flag: flag8,
              flagname: 'Netherlands'
            },
            {
              flag: flag9,
              flagname: 'Australia'
            },
            {
              flag: flag10,
              flagname: 'Italy'
            },
          ]
        },
        {
          c_name: "Max Trading System",
          c_started: "March 16, 2024",
          c_ended:"March 25, 2024",
          c_vol: "300,000",
          c_opens: "29,610",
          c_clicks: 4016,
          c_flag: "singapore.png",
          c_country: "Singapore",
          rank: 3,
          c_bg: "#0089b1",
          days:'10',
          flag_data: [
            {
              flag: flag1,
              flagname: 'US'
            },
           
            {
              flag: flag4,
              flagname: 'UK'
            },
            
            {
              flag: flag9,
              flagname: 'Australia'
            }
          ]
        },
        // {
        //   c_name: "Skilling",
        //   c_started: "01/13/2023",
        //   c_vol: "683,227",
        //   c_opens: "87,643(12.82%)",
        //   c_clicks: 9640,
        //   c_flag: "philippine.png",
        //   c_country: "Phillipines",
        //   rank: 3,
        //   c_bg: "#0089b1",
        // },
      ],
      // flag_data: [
      //   {
      //     flag: flag1,
      //     flagname: 'US'
      //   },
      //   {
      //     flag: flag2,
      //     flagname: 'Germany'
      //   },
      //   {
      //     flag: flag3,
      //     flagname: 'Japan'
      //   },
      //   {
      //     flag: flag4,
      //     flagname: 'UK'
      //   },
      //   {
      //     flag: flag5,
      //     flagname: 'France'
      //   },
      //   {
      //     flag: flag6,
      //     flagname: 'Canada'
      //   },
      //   {
      //     flag: flag7,
      //     flagname: 'India'
      //   },
      //   {
      //     flag: flag8,
      //     flagname: 'Netherlands'
      //   },
      //   {
      //     flag: flag9,
      //     flagname: 'Australia'
      //   },
      //   {
      //     flag: flag10,
      //     flagname: 'Italy'
      //   },
      // ]
    };
  },

  methods: {
    flagImage(fname) {
      return require(`@/assets/images/${fname}`);
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Autoplay, Pagination, A11y],
    };
  },
};
</script>

<style>
table.tbl_new tbody tr td:first-child {
  text-align: left;
}
</style>
